module.exports = __webpack_public_path__ + "img/state-qld.1061dc88.png";